import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ListItemButton,
  Link,
  Menu,
  MenuItem,
  Card,
  CardContent,
} from '@mui/material';
import {
  Layers,
  ExpandLess,
  InsertDriveFile,
  Description,
  MoreVert,
  Search,
  FileCopy,
  Download,
  Share,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Email,
  WhatsApp,
  Bluetooth,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  PictureAsPdf,
  Engineering 
} from '@mui/icons-material';

// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ProvinceRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});

const CommuneRow = styled(TableRow)({
  backgroundColor: '#f9f9f9',
  '&:hover': {
    backgroundColor: '#f0f0f0 !important'
  }
});

const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];

// Structure des données améliorée avec hiérarchie provinces/communes
const interventionData = {
  title: "Répartition des collines/quartiers par province/commune selon les domaines d'intervention des projets/ONG",
  columns: [
    "Pas d'organisme",
    "Agriculture",
    "Elevage",
    "Pisciculture dans les étangs",
    "Pêche",
    "Aquaculture",
    "Foresterie"
  ],
  provinces: [
    {
      name: "BUHUMUZA",
      communes: [
        { name: "BUTAGANZWA", values: ["26", "15", "13", "-", "-", "-", "-"] },
        { name: "BUTIHINDA", values: ["37", "57", "46", "-", "-", "-", "3"] },
        { name: "CANKUZO", values: ["-", "38", "36", "-", "-", "-", "11"] },
        { name: "GISAGARA", values: ["6", "48", "48", "-", "-", "1", "9"] },
        { name: "GISURU", values: ["25", "53", "52", "-", "-", "-", "4"] },
        { name: "MUYINGA", values: ["41", "88", "70", "1", "-", "", "3"] },
        { name: "RUYIGI", values: ["16", "33", "29", "-", "-", "-", "3"] }
      ],
      values: ["151", "332", "294", "1", "-", "1", "33"]
    },
    {
      name: "BUJUMBURA",
      communes: [
        { name: "BUBANZA", values: ["8", "37", "34", "-", "-", "-", "6"] },
        { name: "BUKINANYANA", values: ["15", "25", "32", "-", "-", "-", "5"] },
        { name: "CIBITOKE", values: ["9", "25", "25", "-", "-", "-", "-"] },
        { name: "ISARE", values: ["12", "29", "25", "-", "-", "-", "10"] },
        { name: "MPANDA", values: ["4", "36", "34", "-", "-", "-", "5"] },
        { name: "MUGERE", values: ["29", "28", "20", "-", "-", "-", "13"] },
        { name: "MUGINA", values: ["13", "28", "27", "-", "-", "-", "5"] },
        { name: "MUHUTA", values: ["14", "16", "22", "-", "-", "-", "9"] },
        { name: "MUKAZA", values: ["16", "6", "7", "-", "-", "-", "-"] },
        { name: "NTAHANGWA", values: ["61", "30", "21", "-", "-", "-", "4"] },
        { name: "RWIBAGA", values: ["17", "23", "16", "-", "-", "-", "1"] }
      ],
      values: ["198", "283", "263", "-", "-", "-", "58"]
    },
    {
      name: "BURUNGA",
      communes: [
        { name: "BURURI", values: ["52", "15", "12", "-", "-", "-", "2"] },
        { name: "MAKAMBA", values: ["46", "40", "38", "-", "-", "-", "3"] },
        { name: "MATANA", values: ["33", "23", "29", "-", "-", "-", "-"] },
        { name: "MUSONGATI", values: ["58", "23", "25", "-", "-", "-", "3"] },
        { name: "NYANZA", values: ["33", "45", "45", "-", "-", "1", "8"] },
        { name: "RUMONGE", values: ["38", "24", "22", "-", "1", "2", "-"] },
        { name: "RUTANA", values: ["36", "33", "35", "-", "-", "-", "6"] }
      ],
      values: ["296", "203", "206", "-", "1", "3", "22"]
    },
    {
      name: "BUTANYERERA",
      communes: [
        { name: "BUSONI", values: ["18", "67", "36", "-", "1", "2", "9"] },
        { name: "KAYANZA", values: ["35", "68", "54", "-", "-", "-", "2"] },
        { name: "KIREMBA", values: ["15", "77", "67", "-", "-", "-", "5"] },
        { name: "KIRUNDO", values: ["37", "97", "68", "-", "-", "-", "12"] },
        { name: "MATONGO", values: ["20", "63", "55", "-", "-", "-", "12"] },
        { name: "MUHANGA", values: ["17", "58", "52", "1", "-", "-", "19"] },
        { name: "NGOZI", values: ["20", "60", "65", "1", "-", "-", "5"] },
        { name: "TANGARA", values: ["24", "59", "56", "-", "-", "-", "4"] }
      ],
      values: ["186", "549", "453", "2", "1", "2", "68"]
    },
    {
      name: "GITEGA",
      communes: [
        { name: "BUGENDANA", values: ["9", "33", "24", "-", "-", "-", "8"] },
        { name: "GISHUBI", values: ["48", "46", "32", "-", "-", "-", "4"] },
        { name: "GITEGA", values: ["26", "93", "83", "-", "-", "-", "1"] },
        { name: "KARUSI", values: ["45", "33", "45", "1", "", "1", "16"] },
        { name: "KIGANDA", values: ["6", "41", "40", "-", "-", "-", "1"] },
        { name: "MURAMVYA", values: ["2", "43", "30", "-", "-", "-", "7"] },
        { name: "MWARO", values: ["23", "34", "32", "-", "-", "-", "3"] },
        { name: "NYABIHANGA", values: ["30", "34", "27", "-", "-", "-", "3"] },
        { name: "SHOMBO", values: ["14", "34", "48", "1", "", "-", "12"] }
      ],
      values: ["203", "391", "361", "2", "-", "1", "55"]
    }
  ],
  // Total pour le Burundi
  total: ["1 034", "1 758", "1 577", "5", "2", "7", "236"]
};

const InterventionProjectsPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  const [expandedProvinces, setExpandedProvinces] = useState({});
  
  // Gestion de l'expansion des provinces
  const toggleProvince = (provinceName) => {
    setExpandedProvinces(prev => ({
      ...prev,
      [provinceName]: !prev[provinceName]
    }));
  };

  const handleCopyTable = () => {
    let tableContent = "Province/Commune\t" + interventionData.columns.join("\t") + "\n";
    
    // Ajout du total Burundi
    tableContent += `BURUNDI\t${interventionData.total.join("\t")}\n`;
    
    // Ajout des données par province et commune
    interventionData.provinces.forEach(province => {
      tableContent += `${province.name}\t${province.values.join("\t")}\n`;
      province.communes.forEach(commune => {
        tableContent += `  ${commune.name}\t${commune.values.join("\t")}\n`;
      });
    });
    
    navigator.clipboard.writeText(`${interventionData.title}\n\n${tableContent}`)
      .then(() => alert('Tableau copié dans le presse-papier'))
      .catch(err => console.error('Erreur lors de la copie:', err));
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleShareMenuOpen = (event) => {
    setShareAnchorEl(event.currentTarget);
  };

  const handleDownloadMenuOpen = (event) => {
    setDownloadAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setShareAnchorEl(null);
    setDownloadAnchorEl(null);
  };

  const shareVia = (method) => {
    handleMenuClose();
    const text = `Découvrez les données d'intervention des projets/ONG au Burundi: ${interventionData.title}`;
    const url = window.location.href;
    
    switch(method) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
        break;
      case 'email':
        window.open(`mailto:?subject=${encodeURIComponent(text)}&body=${encodeURIComponent(url)}`, '_blank');
        break;
      case 'bluetooth':
        alert(`Partage via Bluetooth simulé: ${text}`);
        break;
      default:
        if (navigator.share) {
          navigator.share({
            title: text,
            url: url
          }).catch(err => console.log('Erreur de partage:', err));
        } else {
          navigator.clipboard.writeText(url);
          alert('Lien copié dans le presse-papier');
        }
    }
  };

  const downloadFile = (format) => {
    handleMenuClose();
    const blob = new Blob([JSON.stringify(interventionData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `intervention-projets-ong-burundi.${format}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    alert(`Téléchargement du fichier ${format} simulé`);
  };

  // Calcul des indicateurs clés
  const getTotal = (index) => {
    return interventionData.total[index];
  };

  const keyStats = {
    mostAgriculture: interventionData.provinces.reduce((max, province) => 
      parseInt(province.values[1].replace(/\D/g, '') || 0) > parseInt(max.values[1].replace(/\D/g, '') || 0) ? province : max
    ),
    mostForestry: interventionData.provinces.reduce((max, province) => 
      parseInt(province.values[6].replace(/\D/g, '') || 0) > parseInt(max.values[6].replace(/\D/g, '') || 0) ? province : max
    ),
    noOrganization: interventionData.provinces.reduce((max, province) => 
      parseInt(province.values[0].replace(/\D/g, '') || 0) > parseInt(max.values[0].replace(/\D/g, '') || 0) ? province : max
    )
  };
  
  // Filtrage des données basé sur la recherche
  const filteredProvinces = interventionData.provinces.filter(province => {
    const matchesProvince = province.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCommune = province.communes.some(commune => 
      commune.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return matchesProvince || matchesCommune;
  });

  // Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            {drawer}
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        )}

        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
              </Box>
            )}
        
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h6" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {interventionData.title}
                    </Typography>
                  </Box>
                  <Grid container spacing={1} style={{ marginTop: '5px', marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6}></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher province/commune..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '480px' } }}
                      />
                    </Grid>
                  </Grid>
                  
                <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
  <AccordionSummary expandIcon={<ExpandMore />}>
    <Typography variant="subtitle1" fontWeight="bold">
      Indicateurs Clés
    </Typography>
  </AccordionSummary>
  <AccordionDetails>
    <Grid container spacing={2}>
      {/* Agricole */}
      <Grid item xs={12} md={6} lg={4}>
        <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
          <CardContent>
            <Typography variant="subtitle2" color="text.secondary">
              Plus d'interventions agricoles
            </Typography>
            <Typography variant="h6" fontWeight="bold">
              {keyStats.mostAgriculture.name}
            </Typography>
            <Typography variant="body1">
              {keyStats.mostAgriculture.values[1]} collines/quartiers
            </Typography>
            <Typography variant="caption" color="text.secondary">
              ({Math.round(
                (parseInt(keyStats.mostAgriculture.values[1].replace(/\D/g, '') || 0) /
                 parseInt(getTotal(1).replace(/\D/g, '') || 1)) * 100
              )}% du total)
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      {/* Forestière */}
      <Grid item xs={12} md={6} lg={4}>
        <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
          <CardContent>
            <Typography variant="subtitle2" color="text.secondary">
              Plus d'interventions forestières
            </Typography>
            <Typography variant="h6" fontWeight="bold">
              {keyStats.mostForestry.name}
            </Typography>
            <Typography variant="body1">
              {keyStats.mostForestry.values[6]} collines/quartiers
            </Typography>
            <Typography variant="caption" color="text.secondary">
              ({Math.round(
                (parseInt(keyStats.mostForestry.values[6].replace(/\D/g, '') || 0) /
                 parseInt(getTotal(6).replace(/\D/g, '') || 1)) * 100
              )}% du total)
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      {/* Sans intervention */}
      <Grid item xs={12} md={6} lg={4}>
        <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
          <CardContent>
            <Typography variant="subtitle2" color="text.secondary">
              Plus de zones sans intervention
            </Typography>
            <Typography variant="h6" fontWeight="bold">
              {keyStats.noOrganization.name}
            </Typography>
            <Typography variant="body1">
              {keyStats.noOrganization.values[0]} collines/quartiers
            </Typography>
            <Typography variant="caption" color="text.secondary">
              ({Math.round(
                (parseInt(keyStats.noOrganization.values[0].replace(/\D/g, '') || 0) /
                 parseInt(getTotal(0).replace(/\D/g, '') || 1)) * 100
              )}% du total)
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  </AccordionDetails>
</Accordion>

                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des interventions par domaine">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Province/Commune</TableCell>
                          {interventionData.columns.map((column, index) => (
                            <TableCell key={index} align="right">{column}</TableCell>
                          ))}
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {/* Ligne pour le total Burundi */}
                        <ProvinceRow hover>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                            BURUNDI
                          </TableCell>
                          {interventionData.total.map((value, index) => (
                            <TableCell key={index} align="right" sx={{ fontWeight: 'bold' }}>{value}</TableCell>
                          ))}
                        </ProvinceRow>

                        {/* Données par province et commune */}
                        {filteredProvinces.map((province, index) => (
                          <React.Fragment key={index}>
                            <ProvinceRow hover onClick={() => toggleProvince(province.name)}>
                              <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedProvinces[province.name] ? <ExpandLess /> : <ExpandMore />}
                                  {province.name}
                                </Box>
                              </TableCell>
                              {province.values.map((value, idx) => (
                                <TableCell key={idx} align="right">{value}</TableCell>
                              ))}
                            </ProvinceRow>
                            
                            {/* Communes de la province */}
                            {expandedProvinces[province.name] && province.communes.map((commune, communeIdx) => (
                              <CommuneRow key={communeIdx} hover>
                                <TableCell component="th" scope="row" sx={{ pl: 4 }}>
                                  {commune.name}
                                </TableCell>
                                {commune.values.map((value, valueIdx) => (
                                  <TableCell key={valueIdx} align="right">{value}</TableCell>
                                ))}
                              </CommuneRow>
                            ))}
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                    {/*
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Tooltip title="Copier le tableau">
                      <IconButton onClick={handleCopyTable} sx={{ color: primaryColor }}>
                        <FileCopy />
                      </IconButton>
                    </Tooltip>
                    
                    <Tooltip title="Télécharger les données">
                      <IconButton 
                        onClick={handleDownloadMenuOpen}
                        sx={{ color: secondaryColor }}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={downloadAnchorEl}
                      open={Boolean(downloadAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => downloadFile('xlsx')}>
                        <ListItemIcon>
                          <InsertDriveFile fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Excel (.xlsx)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('csv')}>
                        <ListItemIcon>
                          <Description fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>CSV (.csv)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('pdf')}>
                        <ListItemIcon>
                          <PictureAsPdf fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>PDF (.pdf)</ListItemText>
                      </MenuItem>
                    </Menu>
                    
                    <Tooltip title="Partager">
                      <IconButton 
                        onClick={handleShareMenuOpen}
                        sx={{ color: primaryColor }}
                      >
                        <Share />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={shareAnchorEl}
                      open={Boolean(shareAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => shareVia('whatsapp')}>
                        <ListItemIcon>
                          <WhatsApp fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>WhatsApp</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('email')}>
                        <ListItemIcon>
                          <Email fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Email</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('bluetooth')}>
                        <ListItemIcon>
                          <Bluetooth fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Bluetooth</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('other')}>
                        <ListItemIcon>
                          <MoreVert fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Autre méthode</ListItemText>
                      </MenuItem>
                    </Menu>
                  </Box>
                  */}
                </Paper>
                
                {/* Section d'information */}
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      À propos des domaines d'intervention
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      Cette répartition montre le nombre de collines/quartiers où des projets ou ONG interviennent dans différents domaines :
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      <ListItem>
                        <ListItemText 
                          primary="• Agriculture : Interventions dans le domaine agricole" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Elevage : Interventions dans le domaine de l'élevage" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Pisciculture : Interventions dans la pisciculture en étangs" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Pêche : Interventions dans le domaine de la pêche" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Aquaculture : Interventions dans l'aquaculture" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Foresterie : Interventions dans le domaine forestier" 
                        />
                      </ListItem>
                    </List>
                  </AccordionDetails>
                </Accordion>
                
                {/* Notes méthodologiques */}
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentent le nombre de collines/quartiers où des projets ou ONG interviennent dans différents domaines par province/commune.
                    Les chiffres sont basés sur les déclarations des responsables locaux et des organisations intervenantes.
                    Un tiret (-) indique qu'aucune intervention n'a été recensée dans ce domaine pour la localité concernée.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>
      </MainContentWithDrawer>
      <Footer />
    </MainContainer>
  );
};

export default InterventionProjectsPage;